export const WC_CHANGE_INPUT = 'WC_CHANGE_INPUT';
export const WC_CHANGE_OUTPUT = 'WC_CHANGE_OUTPUT';
